module.exports = __webpack_public_path__ + "static/media/ui-icons-documents-on.3e79bc14.svg";